import { useState } from "react";
import Popup from "../../../../../Common/js/components/Popup/Popup.jsx";
import { string, node, number } from "prop-types";

const propTypes = {
  content: string.isRequired,
  btnIcon: node.isRequired,
  triangleAlignment: number,
  width: number,
  top: number,
  left: number,
};

const ToolbarTooltip = (props) => {
  const { content, btnIcon, triangleAlignment, width, top, left } = props;
  const [isHidden, setHidden] = useState(true);

  return (
    <div className="toolbar-tooltip">
      <div
        onMouseEnter={() => setHidden(false)}
        onMouseLeave={() => setHidden(true)}
      >
        {btnIcon}
        <Popup
          className="toolbar-tooltip__content"
          isHidden={isHidden}
          top={top}
          left={left}
          offset={12}
          width={width}
          triangleSide="top"
          triangleAlignment={triangleAlignment}
          flipToContain="viewport"
          nudgeToContain="viewport"
        >
          {content}
        </Popup>
      </div>
    </div>
  );
};

ToolbarTooltip.propTypes = propTypes;
export default ToolbarTooltip;
